import FormattedMessage from 'I18n/components/FormattedMessage';
import PortalIdParser from 'PortalIdParser';
import { Alert } from 'foundations-components/transitional/components/Alert';
import { Button } from 'foundations-components/transitional/components/Button';
import { ButtonWrapper } from 'foundations-components/transitional/components/ButtonWrapper';
import { useEffect, useState } from 'react';
import { useStorage } from 'setup-guide-components/hooks/storage';
import { useTracker } from 'setup-guide-components/hooks/tracking';
import { Flow } from 'signup-constants/Flow';
import { Microapp } from 'signup-constants/Microapp';
import { useDemographics } from '../../hooks/auth';
import { getIsBannerDismissed, setBannerDismissed } from '../../utils/microappBannerUtils';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const MicroappBannerContainer = () => {
  const storage = useStorage();
  const {
    trackUserInteraction,
    trackSectionView
  } = useTracker();
  const demographics = useDemographics();
  const isEligibleToSeeBanner = (demographics === null || demographics === void 0 ? void 0 : demographics.microApp) === Microapp.CampaignAssistant && (demographics === null || demographics === void 0 ? void 0 : demographics.signupType) === Flow.Microapp && !getIsBannerDismissed(storage);
  const [bannerHidden, setBannerHidden] = useState(!isEligibleToSeeBanner);
  useEffect(() => {
    if (isEligibleToSeeBanner) {
      trackSectionView('microapp banner view', demographics.microApp);
    }
  }, [isEligibleToSeeBanner, demographics, trackSectionView]);
  if (bannerHidden) {
    return null;
  }
  return /*#__PURE__*/_jsx("div", {
    children: /*#__PURE__*/_jsx(Alert, {
      closeable: true,
      onClose: () => {
        setBannerHidden(true);
        setBannerDismissed(storage);
        trackUserInteraction('close microapp banner', demographics.microApp);
      },
      titleText: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "app.microappBanner.title"
      }),
      children: /*#__PURE__*/_jsxs(ButtonWrapper, {
        children: [/*#__PURE__*/_jsx(FormattedMessage, {
          message: "app.microappBanner.text"
        }), /*#__PURE__*/_jsx(Button, {
          external: true,
          href: `/campaign-assistant/${PortalIdParser.get()}/recent-campaign`,
          onClick: () => {
            trackUserInteraction('click microapp banner cta', demographics.microApp);
          },
          size: "extra-small",
          use: "tertiary",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "app.microappBanner.cta"
          })
        })]
      })
    })
  });
};